module.exports = __webpack_public_path__ + "img/en.988c5596.svg";